import React from 'react';

import { Selector, SelectProps } from './Selector';

export const CreatableClearableSelector: React.FC<SelectProps> = props => {
  return <Selector {...props} creatable={true} clearable={true} />;
};
